var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesignIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "designIcon",
    transform: "translate(-203.389 -143.885)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55082",
    "data-name": "Path 55082",
    d: "M212.23,204.108l1.57-10.661,34.126-34.126a3.335,3.335,0,0,1,4.608,0l4.482,4.483a3.256,3.256,0,0,1,0,4.608L222.89,202.538Zm3.989-9.445-.941,6.4,6.4-.941L255.2,166.592a.685.685,0,0,0,0-.971l-4.483-4.483a.7.7,0,0,0-.971,0Z",
    transform: "translate(-7.217 -11.846)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55083",
    "data-name": "Path 55083",
    d: "M237.2,334.62l7.274,7.274-1.818,1.818-7.274-7.274Z",
    transform: "translate(-26.116 -155.702)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55084",
    "data-name": "Path 55084",
    d: "M387.74,184.08l7.273,7.273-1.818,1.818-7.273-7.273Z",
    transform: "translate(-149.006 -32.812)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55085",
    "data-name": "Path 55085",
    d: "M354.111,305.5,341.25,292.644l1.819-1.818,11.041,11.042,8.183-8.183-11.25-11.25,1.818-1.818,13.067,13.068Z",
    transform: "translate(-112.54 -111.618)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55086",
    "data-name": "Path 55086",
    d: "M216.531,168.845,203.389,155.7l11.818-11.818,13.062,13.061-1.818,1.818L215.207,147.52l-8.183,8.183,11.324,11.324Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55087",
    "data-name": "Path 55087",
    d: "M271.379,173.58,273.2,175.4l-3.636,3.636-1.818-1.818Z",
    transform: "translate(-52.534 -24.241)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55088",
    "data-name": "Path 55088",
    d: "M301.069,203.28l1.818,1.818-3.636,3.636-1.818-1.818Z",
    transform: "translate(-76.771 -48.486)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55089",
    "data-name": "Path 55089",
    d: "M390.159,292.37l1.818,1.818-3.636,3.636-1.818-1.818Z",
    transform: "translate(-149.497 -121.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55090",
    "data-name": "Path 55090",
    d: "M419.859,322.07l1.818,1.818-3.636,3.636-1.818-1.818Z",
    transform: "translate(-173.742 -145.457)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignIcon);
export default __webpack_public_path__ + "static/media/designIcon.9699bd22c7bf7a32bbeae0840dd2ce05.svg";
export { ForwardRef as ReactComponent };